export default "__VITE_ASSET__DgbNWzWh__"